export default "__VITE_ASSET__28e143e0__"